import { Outlet } from 'react-router-dom';
import { Inbox, List, AlertCircle, FileCode, Network, LogOut } from 'lucide-react';
import { Sidebar, type NavItem } from '@/components/Sidebar';
import { ToastContainer } from '@/components/Toast';
import { useUiStore } from '@/store/uiStore';

const navItems: NavItem[] = [
  { path: '/', label: 'Intake', icon: Inbox, end: true },
  { path: '/list', label: 'Liste', icon: List },
  { path: '/list?status=open', label: 'Offen', icon: AlertCircle },
];

const externalItems: NavItem[] = [
  { path: 'https://issue-api.arkturian.com/docs', label: 'OpenAPI Docs', icon: FileCode },
  { path: 'https://mcp.arkturian.com/issue/', label: 'MCP Endpoint', icon: Network },
];

interface Props {
  user: { email: string };
  onLogout: () => void;
}

export function IssuesLayout({ user, onLogout }: Props) {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      <Sidebar
        brand="issues"
        brandPrefix="agentos"
        navItems={navItems}
        footer={
          collapsed ? null : (
            <div className="space-y-3">
              {/* External links */}
              <div className="text-[9px] tracking-[0.18em] uppercase text-[var(--text-muted)] mb-2">
                external
              </div>
              <div className="space-y-1.5 mb-4">
                {externalItems.map((item) => (
                  <a
                    key={item.path}
                    href={item.path}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 text-[12px] text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors"
                  >
                    <item.icon size={12} strokeWidth={1.5} />
                    {item.label}
                  </a>
                ))}
              </div>

              {/* Account */}
              <div className="text-[9px] tracking-[0.18em] uppercase text-[var(--text-muted)] mb-1">
                account
              </div>
              <div
                className="text-[11px] font-mono text-[var(--text-primary)] truncate mb-2"
                title={user.email}
              >
                {user.email}
              </div>
              <button
                onClick={onLogout}
                className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors"
              >
                <LogOut size={11} strokeWidth={1.5} />
                logout
              </button>
            </div>
          )
        }
      />
      <main className="flex-1 overflow-auto px-16 py-12">
        <Outlet />
      </main>
      <ToastContainer />
    </div>
  );
}
